import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import RanDataFormInputs from '@travel/traveler-core/components/RanDataFormInputs';
import { useTranslation } from '@travel/traveler-core/hooks/useTranslation';
import { getRanData } from '@travel/traveler-core/store/ranStore/selectors';
import { cx } from '@travel/utils';

import SalesPromotionInput from 'components/SalesPromotionInput';
import { SearchFormWithRef } from 'components/SearchForm';
import type { SubmitParams } from 'components/SearchForm/types';

import { Translate } from 'core/translate';
import usePlaceRedirect from 'hooks/usePlaceRedirect';
import type { ProviderInfoQuery } from 'ProviderInformation-Types';
import type { SearchFormQuery } from 'ProviderList-Types';

import styles from './searchBar.module.scss';

type Props = {
  className?: string;
  currentPlaceName: string;
  pageIdentifier: string;
  query: SearchFormQuery | ProviderInfoQuery;
};

function SearchBar(props: Props) {
  const { className, currentPlaceName, query, pageIdentifier } = props;
  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false);
  const ranData = useSelector(getRanData);
  const placeRedirect = usePlaceRedirect();

  const onSubmit = ({ place, formData }: SubmitParams) => {
    const searchQueryString = new URLSearchParams(formData as any).toString();
    placeRedirect(place, searchQueryString);
  };

  return (
    <div data-testid="area-searchForm-wrapper" className={cx(className, styles.wrapper)}>
      <h1 className={styles.searchFormTitleWrapper}>
        <Translate
          id="SEO.Area.Meta.H1"
          data={{ place: currentPlaceName }}
          className={styles.areaTopLabel}
        />
      </h1>
      <SearchFormWithRef
        onPage="area"
        pageIdentifier={pageIdentifier}
        shouldSaveSearch={false}
        currentPlaceName={currentPlaceName}
        onSubmit={onSubmit}
        isAutoOpenDatePicker={isOpenDatePicker}
        setIsAutoOpenDatePicker={setIsOpenDatePicker}
        query={query}
        translateId="Top.Search_Button"
        destinationTextLabel={useTranslation({
          id: 'AreaTop.Search',
          data: { area_name: currentPlaceName },
        })}
        hiddenInput={
          <>
            <SalesPromotionInput {...query} />
            <RanDataFormInputs ranData={ranData} />
          </>
        }
        shouldAutoFillDate={true}
      />
    </div>
  );
}

export default React.memo(SearchBar);
